import { ToolbarItemConfig, ToolbarListType } from '../toolbarTypes';
import { getElementTypeToolsIntersection } from './toolbarAvailableToolsUtils';
import { isFeatureEnabled } from '../../../../common/users/utils/userPropertyUtils';

import * as elementRegistry from '../../../../common/elements/elementRegistry';

import { ElementType } from '../../../../common/elements/elementTypes';
import { ExperimentId } from '../../../../common/experiments/experimentsConstants';
import { CREATE_ELEMENT_TOOLBARS } from '../config/toolbarMainToolListConfig';
import { MilanoteApplicationMode } from '../../../../common/platform/platformTypes';
import { ImMNCurrentUser } from '../../../user/currentUserSelector';

const isDesktopSupported = (tool: ToolbarItemConfig) =>
    tool.appModeAvailability.includes(MilanoteApplicationMode.desktop);

const getCreateElementToolbarTools = (currentUser: ImMNCurrentUser): ToolbarItemConfig[] => {
    if (isFeatureEnabled(ExperimentId.aiAssistant, currentUser)) return CREATE_ELEMENT_TOOLBARS.WITH_AI_ASSISTANT;
    return CREATE_ELEMENT_TOOLBARS.DEFAULT;
};

/**
 * Returns a base list of tools available for the each toolbar type, based on the selected element types.
 */
export const getDesktopBaseToolListItems = (
    elementTypes: Set<ElementType>,
    editorKey: string | undefined,
    currentUser: ImMNCurrentUser,
): Record<ToolbarListType, ToolbarItemConfig[]> => {
    return {
        [ToolbarListType.CREATE_ELEMENT]: getCreateElementToolbarTools(currentUser),
        [ToolbarListType.SELECTED]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementSelectedTools,
        ).filter(isDesktopSupported),
        [ToolbarListType.EDITING]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementEditingTools,
        ).filter(isDesktopSupported),
        [ToolbarListType.EDITING_RANGE]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementEditingRangeTools,
        ).filter(isDesktopSupported),
        [ToolbarListType.MOBILE_TABS]: [],
        [ToolbarListType.MOBILE_UTILS]: [],
    };
};
